<template>
  <div class="screen">
    <div class="screen__header">
      <slot name="header"></slot>
    </div>
    <div class="screen__content">
      <slot name="library"></slot>
      <slot name="editor">
        <Editor />
      </slot>
      <slot name="setting"></slot>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import Editor from '@/components/editor'

// 初始化事件总线
Vue.prototype.$EventBus = new Vue()
export default {
  name: 'ic-screen',
  components: {
    Editor
  },
  props: {
    mode: {
      type: String,
      default: () => 'mobile'
    },
    groups: {
      type: Array,
      require: true
    }
  },
  provide () {
    return {
      mode: this.mode,
      layers: this.layers,
      addLayer: this.addLayer,
      swapLayer: this.swapLayer,
      removeLayer: this.removeLayer,
      updateLayer: this.updateLayer
    }
  },
  watch: {
    layers (newLayers) {
      this.$emit('change', newLayers)
    }
  },
  data () {
    return {
      layers: []
    }
  },
  methods: {
    addLayer (layer) {
      console.log('screen addLayer:', layer)
      this.layers.push(layer)
    },
    removeLayer (layer) {
      const { id } = layer
      const index = this.layers.findIndex(item => item.id === id)
      if (index > -1) {
        this.layers.splice(index, 1)
      }
    },
    swapLayer (source, target) {
      const sourceIndex = this.layers.findIndex(item => item.id === source.id)
      const targetIndex = this.layers.findIndex(item => item.id === target.id)
      if (sourceIndex > -1 && targetIndex > -1) {
        this.layers.splice(sourceIndex, 1, target)
        this.layers.splice(targetIndex, 1, source)
      }
    },
    updateLayer (layer) {
      const { id } = layer
      const index = this.layers.findIndex(item => item.id === id)
      if (index > -1) {
        this.layers.splice(index, 1, layer)
      }
    },
  }
}
</script>

<style>
.screen {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.screen__header {
  width: 100%;
  height: 54px;
  line-height: 54px;
}
.screen__content {
  width: 100%;
  flex: 1;
  position: relative;
}

</style>
